import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import filter from 'lodash/filter';
import { SimpleModal, Textarea } from 'shared/components';
import * as tcRenewalAction from 'features/tc-renewal/duck';
import DigitalAssessmentQuestion from './digital-assessment-question/DigitalAssessmentQuestion';
import { filterOpenEvents } from 'features/tc-renewal/selectors';

const MAX_LENGTH = 720;

class TCDigitalAssessment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tcCycle: {
        ...props.tcCycle,
      },
      answers: {},
      digitalAssessmentAnswers: {},
      isDirty: false,
      optedOutModal: false,
      explanationMessage: '',
      errorsRequired: {},
    };

    this.handleContinue = this.handleContinue.bind(this);
    this.changeAnswer = this.changeAnswer.bind(this);
    this.cancelOptedOutModal = this.cancelOptedOutModal.bind(this);
    this.confirmOptedOutModal = this.confirmOptedOutModal.bind(this);
    this.onExplanationMessageChange = this.onExplanationMessageChange.bind(this);
    this.checkIsDirty = this.checkIsDirty.bind(this);
    this.setAnswers = this.setAnswers.bind(this);
    this.checkForErrors = this.checkForErrors.bind(this);
  }

  componentDidMount() {
    const { actions, tcCycle } = this.props;

    actions.getDigitalAssessmentQuestions(tcCycle.id);
    actions.getDigitalAssessmentAnswers(tcCycle.id);

    actions.getTcCycleEvents(tcCycle.id);
  }

  componentDidUpdate(prevProps) {
    const { answers } = this.state;

    const { digitalAssessmentAnswers, digitalAssessmentQuestions } = this.props;

    if (
      isEmpty(answers) &&
      !isEmpty(digitalAssessmentAnswers) &&
      !isEmpty(digitalAssessmentQuestions) &&
      (prevProps.digitalAssessmentAnswers !== digitalAssessmentAnswers ||
        prevProps.digitalAssessmentQuestions !== digitalAssessmentQuestions)
    ) {
      const updatedAnswers = {};
      digitalAssessmentAnswers.map((answer) => {
        const question = find(digitalAssessmentQuestions, {
          id: answer.cycleFieldId,
        });

        switch (question.type) {
          case 'select_one':
            updatedAnswers[answer.cycleFieldId] = answer.cycleFieldValueId.toString();
            break;
          case 'freeform_text':
            updatedAnswers[answer.cycleFieldId] = answer.freeFormText;
            break;
          case 'numeric':
            updatedAnswers[answer.cycleFieldId] = answer.freeFormText;
            break;
          case 'select_multiple':
            if (isEmpty(updatedAnswers[answer.cycleFieldId])) {
              updatedAnswers[answer.cycleFieldId] = [];
            }
            updatedAnswers[answer.cycleFieldId].push(answer.cycleFieldValueId.toString());
            break;
        }
      });
      this.setState({
        answers: updatedAnswers,
      });
    }
  }

  setAnswers(updatedAnswers) {
    let answers = {};

    const { digitalAssessmentQuestions } = this.props;

    if (!isEmpty(updatedAnswers) && !isEmpty(digitalAssessmentQuestions)) {
      updatedAnswers.map((answer) => {
        const question = find(digitalAssessmentQuestions, {
          id: answer.cycleFieldId,
        });

        switch (question.type) {
          case 'select_one':
            answers[answer.cycleFieldId] = answer.cycleFieldValueId.toString();
            break;
          case 'freeform_text':
            answers[answer.cycleFieldId] = answer.freeFormText;
            break;
          case 'numeric':
            answers[answer.cycleFieldId] = answer.freeFormText;
            break;
          case 'select_multiple':
            if (isEmpty(answers[answer.cycleFieldId])) {
              answers[answer.cycleFieldId] = [];
            }
            answers[answer.cycleFieldId].push(answer.cycleFieldValueId.toString());
            break;
        }
      });

      this.setState({
        answers,
      });
    }
  }

  changeAnswer(questionId, values) {
    const { digitalAssessmentQuestions } = this.props;
    let errors = this.state.errorsRequired;
    const currentQuestion = digitalAssessmentQuestions.find((q) => q.id === questionId);

    if (currentQuestion.cycleFieldValues.length) {
      digitalAssessmentQuestions.forEach((q) => {
        if (q.parentCycleFieldId === questionId) {
          errors[q.id] = false;
        }
      });
    }

    this.setState((prevState) => ({
      answers: {
        ...prevState.answers,
        [questionId]: values,
      },
      errorsRequired: {
        ...prevState.errorsRequired,
        ...errors,
        [questionId]: false,
      },
      isDirty: true,
    }));
  }

  checkForErrors() {
    const { digitalAssessmentQuestions } = this.props;

    const { answers, errorsRequired } = this.state;
    let errorFlag = false;

    digitalAssessmentQuestions.forEach((question) => {
      if (question.requiredFlag && !answers[question.id]) {
        if (question.parentCycleFieldId) {
          const parentQuestion = find(digitalAssessmentQuestions, {
            id: question.parentCycleFieldId,
          });
          const showChildFieldValue = find(parentQuestion.cycleFieldValues, {
            showChildFields: true,
          });
          if (showChildFieldValue && showChildFieldValue.id == answers[parentQuestion.id]) {
            errorsRequired[question.id] = true;
            errorFlag = true;
          }
        } else {
          errorsRequired[question.id] = true;
          errorFlag = true;
        }
      }
    });

    this.setState({
      errorsRequired,
    });
    return errorFlag;
  }

  async handleContinue() {
    const { actions, digitalAssessmentQuestions, digitalAssessmentAnswers, tcCycle } = this.props;

    const { answers, errorsRequired } = this.state;

    if (this.checkForErrors()) {
      const firstError = Object.keys(errorsRequired).find((key) => errorsRequired[key]);

      const elementToScroll = document.getElementById(`${firstError}`);
      elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return false;
    }

    for (let i = 0; i < digitalAssessmentQuestions.length; i++) {
      const question = digitalAssessmentQuestions[i];
      const oldAnswers = filter(digitalAssessmentAnswers, {
        cycleFieldId: question.id,
      });

      if (question.parentCycleFieldId) {
        const parentQuestion = find(digitalAssessmentQuestions, {
          id: question.parentCycleFieldId,
        });
        const showChildFieldValue = find(parentQuestion.cycleFieldValues, {
          showChildFields: true,
        });

        if (showChildFieldValue.id != answers[parentQuestion.id]) {
          // remove all answers for child questions if the parent answer doesn't have showChildFields=true
          if (!isEmpty(oldAnswers)) {
            if (oldAnswers.length) {
              for (let j = 0; j < oldAnswers.length; j++) {
                const answer = oldAnswers[j];
                delete answers[question.id];
                await actions.removeDigitalAssessmentAnswer(answer.id);
              }
            }
          }
        }
      }

      if (question.type === 'select_multiple') {
        // remove unchecked answers
        if (!isEmpty(oldAnswers)) {
          for (let j = 0; j < oldAnswers.length; j++) {
            const oldAnswer = oldAnswers[j];

            if (
              answers[oldAnswer.cycleFieldId] &&
              answers[oldAnswer.cycleFieldId].indexOf(oldAnswer.cycleFieldValueId.toString()) === -1
            ) {
              await actions.removeDigitalAssessmentAnswer(oldAnswer.id);
            }
          }
        }

        if (!isEmpty(answers[question.id])) {
          for (let j = 0; j < answers[question.id].length; j++) {
            const answerValue = answers[question.id][j];
            if (
              !isEmpty(answerValue) &&
              (isEmpty(oldAnswers) ||
                !find(oldAnswers, { cycleFieldValueId: parseInt(answerValue) }))
            ) {
              await actions.setDigitalAssessmentAnswer({
                testCenterCycleId: tcCycle.id,
                cycleFieldId: question.id,
                cycleFieldValueId: answerValue,
              });
            }
          }
        }
      } else if (!isEmpty(answers[question.id])) {
        if (
          !isEmpty(oldAnswers) &&
          (oldAnswers[0].cycleFieldValueId == answers[question.id] ||
            oldAnswers[0].freeFormText == answers[question.id])
        ) {
          // skip if is the same answer
        } else {
          const fieldValue = {
            testCenterCycleId: tcCycle.id,
            cycleFieldId: question.id,
          };

          if (!isEmpty(oldAnswers)) {
            fieldValue.id = oldAnswers[0].id;
          }

          switch (question.type) {
            case 'select_one':
              fieldValue.cycleFieldValueId = answers[question.id];
              break;
            case 'freeform_text':
              fieldValue.freeFormText = answers[question.id];
              break;
            case 'numeric':
              fieldValue.freeFormText = answers[question.id];
              break;
          }

          await actions.setDigitalAssessmentAnswer(fieldValue);
        }
      } else if (
        question.type === 'freeform_text' &&
        !isEmpty(oldAnswers) &&
        isEmpty(answers[question.id])
      ) {
        await actions.removeDigitalAssessmentAnswer(oldAnswers[0].id);
      }
    }

    const updatedAnswers = await actions.getDigitalAssessmentAnswers(tcCycle.id);
    if (updatedAnswers) {
      this.setAnswers(updatedAnswers);
      this.setState({
        isDirty: false,
      });
    }

    return await this.checkOptedOutEvents();
  }

  async checkOptedOutEvents() {
    return new Promise((resolve) => {
      const { events } = this.props;
      if (!events.length) {
        this.modalCallback = resolve;

        this.setState({
          optedOutModal: true,
        });
      } else {
        resolve(true);
      }
    });
  }

  cancelOptedOutModal() {
    this.setState((prevState) => ({
      optedOutModal: !prevState.optedOutModal,
    }));

    if (this.modalCallback) {
      this.modalCallback(false);
    }

    return false;
  }

  async confirmOptedOutModal() {
    const { explanationMessage } = this.state;
    const { actions, tcCycle } = this.props;

    this.setState((prevState) => ({
      optedOutModal: !prevState.optedOutModal,
    }));

    await actions.updateTCCycle({
      id: tcCycle.id,
      renewalNotes: explanationMessage,
      storageLocation: tcCycle.storageLocation,
      storageContainer: tcCycle.storageContainer,
      storageLocationOther: tcCycle.storageLocationOther,
      storageContainerOther: tcCycle.storageContainerOther,
      storageOtherUse: tcCycle.storageOtherUse,
      storageStudentAccess: tcCycle.storageStudentAccess,
    });

    if (this.modalCallback) {
      this.modalCallback(true);
    }

    return true;
  }

  onExplanationMessageChange(e) {
    this.setState({
      explanationMessage: e.target.value,
    });
  }

  checkIsDirty() {
    return this.state.isDirty;
  }

  render() {
    const { answers, errorsRequired } = this.state;
    const { digitalAssessmentQuestions, tcCycle, currentStepId } = this.props;

    return (
      <section className="security-information-container">
        <h4>{this.props.t('testCenter.digitalAssessment.title')}</h4>
        <p className="mb-4">{this.props.t('testCenter.digitalAssessment.details')}</p>

        {digitalAssessmentQuestions?.map((question, key) => {
          let displayQuestion = true;
          if (question.parentCycleFieldId) {
            const parentQuestion = find(digitalAssessmentQuestions, {
              id: question.parentCycleFieldId,
            });
            const showChildFieldValue = find(parentQuestion.cycleFieldValues, {
              showChildFields: true,
            });

            if (showChildFieldValue && showChildFieldValue.id != answers[parentQuestion.id]) {
              displayQuestion = false;
            }
          }

          const lastChild =
            question.parentCycleFieldId &&
            (isEmpty(digitalAssessmentQuestions[key + 1]) ||
              question.parentCycleFieldId !=
                digitalAssessmentQuestions[key + 1].parentCycleFieldId);

          return (
            <DigitalAssessmentQuestion
              {...question}
              error={errorsRequired[question.id]}
              changeAnswer={this.changeAnswer}
              selectedValue={answers[question.id]}
              selectedValues={answers[question.id]}
              lastChild={lastChild}
              displayQuestion={displayQuestion}
              key={key}
            />
          );
        })}

        <SimpleModal
          isOpen={this.state.optedOutModal}
          onCancel={this.cancelOptedOutModal}
          onConfirm={this.confirmOptedOutModal}
          confirmLabel={this.props.t('common.labels.continue')}
          cancelLabel={this.props.t('common.labels.back')}
          headline={this.props.t('testCenter.optedOutModal.title')}
          containerClassName="opted-out-modal-container">
          <ExplanationMessage
            explanationMessage={this.state.explanationMessage}
            onExplanationMessageChange={this.onExplanationMessageChange}
            tcCycleId={tcCycle.id}
            handleBack={this.props.handleBackSteps}
            currentStepId={currentStepId}
          />
        </SimpleModal>
      </section>
    );
  }
}

const ExplanationMessage = (props) => {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <div className="mb-3">
          <span>{t('testCenter.optedOutModal.intentCheckMessage')}</span>
          <button
            className="pl-0 btn-link text-pacific-blue fw-bold"
            onClick={() => props.handleBack(props.currentStepId, 'review-test-dates')}>
            <span>{t('testCenter.optedOutModal.updateMessage')}.</span>
          </button>
        </div>
        <p>{t('testCenter.optedOutModal.noteMessage')}</p>
      </div>
      <div className="freeform-text">
        <h6 className="title">{t('testCenter.optedOutModal.messageLabel')}</h6>
        <Textarea
          className="mb-1"
          name="explanation-message"
          value={props.explanationMessage}
          onChange={props.onExplanationMessageChange}
          maxLength={MAX_LENGTH}
          optionalText="common.labels.optional"
        />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    tcCycle: state.tcRenewal.tcCycle,
    digitalAssessmentQuestions: state.tcRenewal.digitalAssessmentQuestions,
    digitalAssessmentAnswers: state.tcRenewal.digitalAssessmentAnswers,
    events: filterOpenEvents(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...tcRenewalAction }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withTranslation(null, { withRef: true })(TCDigitalAssessment));

TCDigitalAssessment.propTypes = {
  tcCycle: PropTypes.shape({}).isRequired,
  digitalAssessmentQuestions: PropTypes.arrayOf(PropTypes.shape({})),
  digitalAssessmentAnswers: PropTypes.arrayOf(PropTypes.shape({})),
  currentStepId: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    getDigitalAssessmentQuestions: PropTypes.func,
    getDigitalAssessmentAnswers: PropTypes.func,
    setDigitalAssessmentAnswer: PropTypes.func,
    removeDigitalAssessmentAnswer: PropTypes.func,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
